"use strict";

var imageZoomGlobal = undefined;
var isTouchDevice = document.querySelector('html').classList.contains('has-touch');
var isMobile = isTouchDevice && screen.width <= 768;

if (!isMobile) {
  var intID = setInterval(function () {
    var productImages = Array.from(document.querySelectorAll('.product-gallery--image > div'));
  
    // SS_2020: add in condition to not do this on mobile
    if (productImages !== null && productImages !== undefined && productImages.length > 0) {
      productImages.forEach(function (pImage) {
        var imageSrc = pImage.getAttribute('data-image');
        pImage.addEventListener('click', function () {
          return triggerPopup(imageSrc, '0');
        });
      });

      document.querySelector('[data-image-popup-close-btn]').addEventListener('click', closePopup);
      window.addEventListener('keydown', function (event) {
        if (event.key === "Escape") {
          closePopup();
        }
  
        return;
      });
      document.querySelector('.popup-overlay').addEventListener('click', function (e) {
        var popupDims = document.querySelector('.popup-image-viewer').getBoundingClientRect();
  
        if (e.pageX < popupDims.left || e.pageX > popupDims.right || e.pageY < popupDims.top || e.pageY > popupDims.bottom) {
          closePopup();
        }
      });
      clearInterval(intID);
    }
  }, 100);
}

var hasEventListener = false;
var zoomOn = false;

function triggerPopup(image, thumbnailIndex) {
  document.querySelector('[data-image-popup-close-btn]').addEventListener('click', closePopup);
  window.addEventListener('keydown', function (event) {
    if (event.key === "Escape") {
      closePopup();
    }

    return;
  });
  document.querySelector('[data-image-popup-close-btn]').addEventListener('click', closePopup);
  // we need to scroll to the top of the page because of the way the z-indexes are for the header and the main body
  $('html, body').animate({
    scrollTop: 0
  }, 0);
  var popupEl = document.getElementById('popup-viewer');
  popupEl.style.setProperty('display', 'block'); // we need to disable the scrolling because the header gets in the way otherwise

  document.querySelector('body').style.setProperty('overflow', 'hidden'); // while the popup is enabled, we need to send the header to the back
  document.querySelector('.site-main').classList.toggle('above-all');
  
//   document.querySelector('.site-header-wrapper').style.setProperty('z-index', '499');
  var thumbnails = Array.from(document.querySelectorAll('.popup-image-nav button'));
  thumbnails.forEach(function (t) {
    t.classList.remove('popup-thumbnail-selected');
  });
  var thumbnailButton = document.querySelectorAll(".popup-image-nav [data-product-thumbnail=\"".concat(thumbnailIndex, "\"]"));
  Array.from(thumbnailButton).forEach(function(t) {
    t.classList.add('popup-thumbnail-selected');
  });
  var imageZoom = document.getElementById('popup-image-zoom');
  imageZoomGlobal = imageZoom; // calculate and set the height of the image holder div, and the thumbnail nav wrapper

  var viewerHeight = document.querySelector('.popup-image-viewer').getBoundingClientRect().height;
  var imageDivTop = imageZoom.getBoundingClientRect().top;
  var thumbnailNavWrapper = document.querySelectorAll('.popup-image-nav');
  popupEl.classList.add('visible');
  imageZoom.style.setProperty('height', "".concat(viewerHeight - imageDivTop, "px"));
  imageZoom.style.setProperty('background-image', "url(".concat(image, ")"));
  thumbnailNavWrapper.forEach(function (tn) {
    if (!Array.from(tn.classList).includes('not-desktop')) {
      tn.style.setProperty('height', "".concat(viewerHeight - imageDivTop - 44, "px"));
    }
  }); // add the zoom after the user clicks on the image

  if (!hasEventListener) {
    console.log('adding event listener to popup image');

    if (Array.from(imageZoom.classList).includes("zoom-off")) {
      imageZoom.addEventListener('click', function (e) {
        addZoom(imageZoom, e);
      });
      hasEventListener = true;
    }
  }
}

function generateYoutubeLink(videoID) {
  return "https://www.youtube.com/embed/".concat(videoID, "?modestbranding=true&amp;showinfo=false&amp;controls=false&amp;rel=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fray-padula-holdings.myshopify.com&amp;widgetid=1");
}

function changeImageInPopup(thumbnailIndex, isVideo, videoLink) {
  var popupVideo = document.getElementById('popup-video');

  if (isVideo === "true") {
    var videoIDParam = videoLink.split('?')[1].split('&').filter(function (p) {
      return p.slice(0, 2) === "v=";
    });

    if (videoIDParam.length) {
      var videoID = videoIDParam[0].split('=')[1];
      var video = document.querySelector('#popup-video iframe');
      var popupImageViewerHeight = document.querySelector('.popup-image-viewer').getBoundingClientRect().height;
      var productVendorHeight = document.querySelector('.product-vendor').getBoundingClientRect().height;
      var productTitleHeight = document.querySelector('.product-title').getBoundingClientRect().height;
      video.src = generateYoutubeLink(videoID);

      if (screen.width > 1024) {
        video.height = popupImageViewerHeight - 50 - productVendorHeight - productTitleHeight - 10 - 35 - 14;
      } else {
        video.width = document.querySelector('.popup-image-viewer').getBoundingClientRect().width - 50;
      }
    }

    var thumbnails = Array.from(document.querySelectorAll('.popup-image-nav button'));
    thumbnails.forEach(function (t) {
      t.classList.remove('popup-thumbnail-selected');
    });
    var thumbnailButton = document.querySelectorAll(".popup-image-nav [data-product-thumbnail=\"".concat(thumbnailIndex, "\"]"));
    Array.from(thumbnailButton).forEach(function(t) {
      t.classList.add('popup-thumbnail-selected');
    });
    imageZoomGlobal.style.setProperty('display', 'none');
    popupVideo.style.setProperty('display', 'block');
  } else {
    popupVideo.style.setProperty('display', 'none');
    imageZoomGlobal.style.setProperty('display', 'block'); // remove zoom

    if (imageZoomGlobal !== undefined) {
      imageZoomGlobal.onmousemove = undefined;
      imageZoomGlobal.onmouseleave = undefined;
      imageZoomGlobal.classList.remove('zoom-on');
      imageZoomGlobal.classList.add('zoom-off');
      Object.assign(imageZoomGlobal.style, {
        backgroundPosition: 'left top',
        backgroundSize: 'contain'
      });
      zoomOn = false;
    }

    var productImages = Array.from(document.querySelectorAll('.product-gallery--image > div'));
    var imageToShow = productImages[Number(thumbnailIndex)].getAttribute('data-image');

    var _thumbnails = Array.from(document.querySelectorAll('.popup-image-nav button'));

    _thumbnails.forEach(function (t) {
      t.classList.remove('popup-thumbnail-selected');
    });

    var _thumbnailButton = document.querySelectorAll(".popup-image-nav [data-product-thumbnail=\"".concat(thumbnailIndex, "\"]"));
    Array.from(_thumbnailButton).forEach(function(t) {
      t.classList.add('popup-thumbnail-selected');
    });

    imageZoomGlobal.style.setProperty('background-image', "url(".concat(imageToShow, ")"));
  }
}

function closePopup() {
  var popupEl = document.getElementById('popup-viewer');
  popupEl.classList.remove('visible');
  document.querySelector('.site-main').classList.toggle('above-all');
  setTimeout(function () {
    document.querySelector('body').style.setProperty('overflow', 'visible');
//     document.querySelector('.site-header-wrapper').style.setProperty('z-index', '700');
    popupEl.style.setProperty('display', 'none');
  }, 1000); // remove zoom

  if (imageZoomGlobal !== undefined) {
    imageZoomGlobal.onmousemove = undefined;
    imageZoomGlobal.onmouseleave = undefined;
    imageZoomGlobal.classList.remove('zoom-on');
    imageZoomGlobal.classList.add('zoom-off');
    Object.assign(imageZoomGlobal.style, {
      backgroundPosition: 'left top',
      backgroundSize: 'contain'
    });
    zoomOn = false;
  } // remove escape key listener


  window.addEventListener('keydown', function () {});
} 

// Modified from https://www.cssscript.com/image-zoom-pan-hover-detail-view/


var addZoom = function addZoom(container, e) {
  if (!zoomOn) {
    // FETCH CONTAINER + IMAGE
    var imgsrc = container.currentStyle || window.getComputedStyle(container, false),
        imgsrc = imgsrc.backgroundImage.slice(4, -1).replace(/"/g, ""),
        img = new Image(); // LOAD IMAGE + ATTACH ZOOM

    img.src = imgsrc;

    img.onload = function () {
      var imgWidth = img.naturalWidth,
          imgHeight = img.naturalHeight,
          ratio = imgHeight / imgWidth;
      var boxWidth = container.clientWidth,
          xPos = e.pageX - container.getBoundingClientRect().left,
          yPos = e.pageY - container.getBoundingClientRect().top,
          xPercent = xPos / (boxWidth / 100) + '%',
          yPercent = yPos / (boxWidth * ratio / 100) + '%';
      Object.assign(container.style, {
        backgroundPosition: xPercent + ' ' + yPercent,
        backgroundSize: imgWidth + 'px'
      });
      container.classList.remove('zoom-off');
      container.classList.add('zoom-on'); // ZOOM ON MOUSE MOVE

      container.onmousemove = function (e) {
        var boxWidth = container.clientWidth,
            xPos = e.pageX - container.getBoundingClientRect().left,
            yPos = e.pageY - container.getBoundingClientRect().top,
            xPercent = xPos / (boxWidth / 100) + '%',
            yPercent = yPos / (boxWidth * ratio / 100) + '%';
        Object.assign(container.style, {
          backgroundPosition: xPercent + ' ' + yPercent,
          backgroundSize: imgWidth + 'px'
        });
      }; 
      
      // RESET ON MOUSE LEAVE

      container.onmouseleave = function (e) {
        Object.assign(container.style, {
          backgroundPosition: 'left top',
          backgroundSize: 'contain'
        });
      };

      zoomOn = true;
    };
  } else {
    container.onmousemove = undefined;
    container.onmouseleave = undefined;
    container.classList.remove('zoom-on');
    container.classList.add('zoom-off');
    Object.assign(container.style, {
      backgroundPosition: 'left top',
      backgroundSize: 'contain'
    });
    zoomOn = false;
  }
};